/**
 * Generated from ch10_p04.fla
 */
export function ch10_p04(this: Ich10_p04) {
	const characters = this.characters;
	if (!characters[0] && characters.elementFactory) {
		characters[0] = characters.elementFactory(0,undefined);
	}
	if (characters[0]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters.call(characters[0] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters);
		characters[0].x = 824.25;
		characters[0].y = 768;
		characters[0].width = 904.50;
		characters[0].height = 642.50;
		characters[0].alpha = 1;
		if (characters[0].onLayout) characters[0].onLayout();
	}
	if (!characters[1] && characters.elementFactory) {
		characters[1] = characters.elementFactory(1,undefined);
	}
	if (characters[1]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters.call(characters[1] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters);
		characters[1].x = 842;
		characters[1].y = 768;
		characters[1].width = 940.00;
		characters[1].height = 642.50;
		characters[1].alpha = 1;
		if (characters[1].onLayout) characters[1].onLayout();
	}
	const confetti = this.confetti;
	if (!confetti[0] && confetti.elementFactory) {
		confetti[0] = confetti.elementFactory(0,undefined);
	}
	if (confetti[0]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1.call(confetti[0] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1);
		confetti[0].x = 789.25;
		confetti[0].y = 298;
		confetti[0].width = 1403.50;
		confetti[0].height = 596.00;
		confetti[0].alpha = 1;
		if (confetti[0].onLayout) confetti[0].onLayout();
	}
	if (!confetti[1] && confetti.elementFactory) {
		confetti[1] = confetti.elementFactory(1,undefined);
	}
	if (confetti[1]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2.call(confetti[1] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2);
		confetti[1].x = 805.25;
		confetti[1].y = 313.25;
		confetti[1].width = 1493.50;
		confetti[1].height = 561.50;
		confetti[1].alpha = 1;
		if (confetti[1].onLayout) confetti[1].onLayout();
	}
	if (!confetti[2] && confetti.elementFactory) {
		confetti[2] = confetti.elementFactory(2,undefined);
	}
	if (confetti[2]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3.call(confetti[2] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3);
		confetti[2].x = 741;
		confetti[2].y = 321.75;
		confetti[2].width = 1247.00;
		confetti[2].height = 425.50;
		confetti[2].alpha = 1;
		if (confetti[2].onLayout) confetti[2].onLayout();
	}
	if (!confetti[3] && confetti.elementFactory) {
		confetti[3] = confetti.elementFactory(3,undefined);
	}
	if (confetti[3]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy.call(confetti[3] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy);
		confetti[3].x = 775.25;
		confetti[3].y = 416.75;
		confetti[3].width = 1423.50;
		confetti[3].height = 702.50;
		confetti[3].alpha = 1;
		if (confetti[3].onLayout) confetti[3].onLayout();
	}
	if (!confetti[4] && confetti.elementFactory) {
		confetti[4] = confetti.elementFactory(4,undefined);
	}
	if (confetti[4]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4.call(confetti[4] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4);
		confetti[4].x = 882;
		confetti[4].y = 305.75;
		confetti[4].width = 1337.00;
		confetti[4].height = 611.50;
		confetti[4].alpha = 1;
		if (confetti[4].onLayout) confetti[4].onLayout();
	}
	if (!confetti[5] && confetti.elementFactory) {
		confetti[5] = confetti.elementFactory(5,undefined);
	}
	if (confetti[5]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy.call(confetti[5] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy);
		confetti[5].x = 879.5;
		confetti[5].y = 340;
		confetti[5].width = 1427.00;
		confetti[5].height = 680.00;
		confetti[5].alpha = 1;
		if (confetti[5].onLayout) confetti[5].onLayout();
	}
	if (!confetti[6] && confetti.elementFactory) {
		confetti[6] = confetti.elementFactory(6,undefined);
	}
	if (confetti[6]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5.call(confetti[6] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5);
		confetti[6].x = 791.25;
		confetti[6].y = 230;
		confetti[6].width = 1268.50;
		confetti[6].height = 451.00;
		confetti[6].alpha = 1;
		if (confetti[6].onLayout) confetti[6].onLayout();
	}
	if (!confetti[7] && confetti.elementFactory) {
		confetti[7] = confetti.elementFactory(7,undefined);
	}
	if (confetti[7]) {
		ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy.call(confetti[7] as Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy);
		confetti[7].x = 817.5;
		confetti[7].y = 307;
		confetti[7].width = 1570.00;
		confetti[7].height = 614.00;
		confetti[7].alpha = 1;
		if (confetti[7].onLayout) confetti[7].onLayout();
	}
	const bg = this.bg;
	ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const frameRight = this.frameRight;
	ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_bg(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p04_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p04_characters", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p05_characters", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer77copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer78copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer5", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer79copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeRRframe(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeLLframe(this: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich10_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich10_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich10_p04Sprite extends Ich10_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich10_p04Text extends Ich10_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich10_p04Polygon extends Array<number> {
}
interface Ich10_p04 {
	readonly characters: Ich10_p04Array<Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters>;
	readonly confetti: Ich10_p04Array<Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5|Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy>;
	readonly bg: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_bg;
	readonly frameRight: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeRRframe;
	readonly frameLeft: Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeLLframe;
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_bg extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_characters extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p05_characters extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer1 extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiLayer2 extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer3 extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiyellowLayer77copy extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer4 extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confetticyanLayer78copy extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer5 extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_confettiredLayer79copy extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeRRframe extends Ich10_p04Sprite {
}
interface Ich10_p04_hh_ch010_72dpi_p0405psdAssetchp10_p04_wcframeLLframe extends Ich10_p04Sprite {
}
